export const environment = {
  production: false,
  existingCaseWorthyAPIURL:
  "https://uat.cw.caseworthy.net/CaseWorthy.API/",
nextGenAccountsAPIURL: "https://uat.api.cwe.cw.caseworthy.net/account/services/v1/",
nextGenFormsAPIURL: "https://uat.api.cwe.cw.caseworthy.net/forms/services/v1/",
nextGenQueryAPIURL: "https://uat.api.cwe.cw.caseworthy.net/query-apbuilder/services/v1/",
nextGenServerUrl: "https://uat.api.cwe.cw.caseworthy.net/",
};
